import { StrictMode, useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { App } from '../App';
import { ENABLE_MAINTENANCE_MODE } from '../Constants';
import ErrorBoundary from '../ErrorBoundary';
import { Maintenance } from '../maintenance';
import { doesCookieExist } from '../utils/cookies';

const AppContainer = ({ store, persistor }) => {
  const [cssLoaded, setCssLoaded] = useState(false);
  const brand = process.env.REACT_APP_SITE_CODE || 'BF';

  // Dynamically import the SCSS based on brand and set a flag once CSS is loaded
  useEffect(() => {
    const onCssLoad = () => {
      setCssLoaded(true);
    };

    switch (brand) {
      case 'BF':
      case 'SN':
        import('../../skins/BF-SN-skin.scss').then(onCssLoad);
        break;
      case 'MT':
        import('../../skins/MT/skin.scss').then(onCssLoad);
        break;
      default:
        import('../../skins/BF-SN-skin.scss').then(onCssLoad);
        break;
    }

    return () => setCssLoaded(false);
  }, [brand]);

  if (!cssLoaded) {
    return null;
  }

  // Once CSS is loaded, render the actual app content
  return ENABLE_MAINTENANCE_MODE && !doesCookieExist('GrantUserAccess=') ? (
    <StrictMode>
      <Maintenance />
    </StrictMode>
  ) : (
    <StrictMode>
      <HelmetProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </PersistGate>
        </Provider>
      </HelmetProvider>
    </StrictMode>
  );
};

export default AppContainer;
